import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-staff-availability',
  templateUrl: './staff-availability.component.html',
  styleUrls: ['./staff-availability.component.css']
})
export class StaffAvailabilityComponent implements OnInit {

  searchForm: FormGroup | any;

  constructor() { }

  ngOnInit() {
    this.searchForm = new FormGroup({
      'search': new FormControl(''),
      'fromDate': new FormControl(''),
    })
  }

}
